import { NavLink, Outlet, useLocation, useNavigate } from "react-router-dom";
import { CalendarDays, Handshake, LogIn, Medal, Newspaper, FolderOpenDot, Building2 } from "lucide-react";

import { useAuth } from "@/context/AuthContext";
import MobileNavigation from "@/components/MobileNavigation";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_fight-bracket-pro/artifacts/bcn58mfl_WBCGermany.png";
const publicItems = [
  { to: "/", label: "News", icon: Newspaper, end: true },
  { to: "/projekte", label: "Projekte", icon: FolderOpenDot },
  { to: "/sponsoren", label: "Sponsoren", icon: Handshake },
  { to: "/gyms", label: "WBC Gyms", icon: Building2 },
  { to: "/kalender", label: "Kalender", icon: CalendarDays },
  { to: "/rangliste", label: "Rangliste", icon: Medal },
];

/**
 * PublicShell für öffentliche Seiten (News, Projekte, Sponsoren, Gyms,
 * Kalender, Rangliste). Desktop-Sidebar wird gerendert; die mobile Navigation
 * kommt zentral aus `MobileNavigation`, damit sie 1:1 identisch zur
 * eingeloggten Shell ist (gleicher Burger, gleiche Admin-Bottombar).
 */
export default function PublicShell() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div className="app-shell public-shell" data-testid="public-shell">
      <aside className="sidebar">
        <div className="brand-lockup"><img src={LOGO_URL} alt="WBC Germany" /><span>WBC<br />MUAY THAI</span></div>
        <nav>{publicItems.map(({ to, label, icon: Icon, end }) => <NavLink key={to} to={to} end={end} className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid={`public-nav-${label.toLowerCase().replace(" ","-")}`}><Icon size={19} /><span>{label}</span></NavLink>)}</nav>
        <div className="sidebar-bottom">
          {user
            ? <button className="nav-link" onClick={() => navigate("/events")} data-testid="public-to-app-button"><LogIn size={19} /><span>Zum Portal</span></button>
            : <>
                <button className="nav-link" onClick={() => navigate("/login")} data-testid="public-login-button"><LogIn size={19} /><span>Anmelden</span></button>
                <button className="nav-link" onClick={() => navigate("/register")} data-testid="public-register-button"><LogIn size={19} /><span>Registrieren</span></button>
              </>}
        </div>
      </aside>

      <MobileNavigation />

      <main className="page-main" key={location.pathname}><Outlet /></main>
    </div>
  );
}
